// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("./common/http.res.js");
var Image$ReactHooksTemplate = require("./common/image.res.js");

function LandingPage(props) {
  var checkOrgSetup = function (param) {
    Js_promise.then_((function (json) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("pending", Json_decode.string, param);
                  }), json);
            switch (status) {
              case "pending" :
                  console.log("Organization setup not complete");
                  return Promise.resolve();
              case "redirect" :
                  var path = Json_decode.field("path", (function (param) {
                          return Json_decode.withDefault("/", Json_decode.string, param);
                        }), json);
                  console.log("Redirecting to", path);
                  RescriptReactRouter.push(path);
                  window.location.reload();
                  return Promise.resolve();
              default:
                return Promise.resolve();
            }
          }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/organizations/check_setup"));
  };
  React.useEffect((function (param) {
          checkOrgSetup();
          var intervalId = setInterval((function (param) {
                  checkOrgSetup();
                }), 10000);
          return (function (param) {
                    clearInterval(intervalId);
                  });
        }), []);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("img", {
                                    className: "h-40-px w-120-px",
                                    src: Image$ReactHooksTemplate.geckolystLogoWithText
                                  }),
                              className: "flex items-center"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("button", {
                                      children: "Need help?",
                                      className: "text-sm text-darksilver hover:text-indigo-600 p-2"
                                    }),
                                JsxRuntime.jsxs("button", {
                                      children: [
                                        JsxRuntime.jsx("img", {
                                              src: Image$ReactHooksTemplate.headphone
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: "Contact Us",
                                              className: "flex items-center h-full w-20"
                                            })
                                      ],
                                      className: "rounded-lg text-darkcharcoal border border-gainsboro flex gap-2 p-2 font-medium text-sm"
                                    })
                              ],
                              className: "flex gap-2"
                            })
                      ],
                      className: "flex justify-between w-full px-6 py-4 border-b border-platinum"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("h1", {
                                    children: "Thank you for signing up",
                                    className: "text-darksilver text-lg font-normal px-4"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "We are setting things up for you",
                                    className: "text-darkcharcoal text-2xl font-medium px-4"
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "loader"
                                  })
                            ],
                            className: "text-center flex flex-col gap-2"
                          }),
                      className: "flex items-center justify-center h-full bg-ghostwhiteblue"
                    })
              ],
              className: "h-full flex flex-col"
            });
}

var make = LandingPage;

exports.make = make;
/* react Not a pure module */
